class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.inputWrapper = "[data-input-wrapper]";
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );
    this.installmentsForm = document.querySelector(
      `#Product-Installments-${this.dataset.installmentsFormId}`
    );

    this.addEventListener("change", this.onVariantChange.bind(this));

    this.updateOptions();
    this.updateVariantStatuses();
    this.updateVariant();
    this.toggleForm();
    this.updateVariantLabel();
    this.hideUnavailableVariants();
    this.updateVariantSelectSize();
    this.variantColorSwatch();
    this.checkInitialVariantAvailability();
    this.renderProductInfo();

    // this.form.toggleAddButton(!this.currentVariant.available, '');
  }

  // Check initial variant availability
  checkInitialVariantAvailability() {
    this.currentVariant = this.getVariantData();

    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    if (!this.currentVariant.available) {
      this.form.toggleAddButton(true, window.variantStrings.soldOut);
    } else {
      this.form.toggleAddButton(false, "");
    }
    this.updateInventoryNoticeDisplay(this.currentVariant.available);
  }

  updateInventoryNoticeDisplay(isAvailable) {
    const inventoryNotice = document.querySelector(
      ".product__inventory-notice"
    );
    if (!inventoryNotice) return;
    if (isAvailable) {
      inventoryNotice.style.display = "flex";
    } else {
      inventoryNotice.style.display = "none";
    }
  }

  updateVariantSelectSize() {
    const items = this.querySelectorAll(".option-size");
    const labels = this.querySelectorAll(".option-size + label");
    const atcForm = document.querySelector(".product-form-toggle");
    const selectSizeForm = document.querySelector(
      ".product-select-size-button"
    );

    labels.forEach((i) => i.classList.remove("is-active"));

    items.forEach((item) => {
      item.nextElementSibling.addEventListener("click", function () {
        labels.forEach((i) => i.classList.remove("is-active"));
        this.classList.add("is-active");

        // show atc form
        atcForm.classList.remove("hidden");
        selectSizeForm.classList.add("hidden");

        document
          .querySelector(".product__inventory-notice")
          .classList.remove("hidden");
      });
    });
  }
  updateVariantStatuses() {
    const optionOneValue = this.querySelector(this.inputWrapper).querySelector(
      ":checked"
    ).value;
    const selectedOptionOneVariants = this.variants.filter(
      (variant) => optionOneValue === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(this.inputWrapper)];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const listOfAvailableOptions = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];

      optionInputs.forEach((input) => {
        const inputIsDisabled = !listOfAvailableOptions.includes(
          input.getAttribute("value")
        );

        // input.disabled = inputIsDisabled;
        input.setAttribute("is-disabled", inputIsDisabled);
        if (input.tagName.toLowerCase() === "option") {
          const escapedValue = input.value.replace(/"/g, '\\"');
          const selector = `button[data-value="${escapedValue}"]`;
          const button = input
            .closest("dropdown-input")
            .querySelector(selector);
          if (button) {
            button.disabled = inputIsDisabled;
          }
        }
        if (!this.productBar) return;
        const inputId = input.dataset.id || input.id;
        const productBarInput = this.productBar.querySelector(
          `option[data-id="${inputId}"]`
        );
        if (!productBarInput) return;
        productBarInput.disabled = inputIsDisabled;
      });
    });
  }

  onVariantChange(event) {
    if (event.target.type === "number") return;
    this.updateOptions();
    if (this.currentVariant === this.getVariantData()) return;

    this.updateVariant();
    this.updateVariantStatuses();
    this.productBarUpdateOptions();
    this.updatePickupAvailability();
    this.form.removeAttribute("data-has-selling-plan");
    this.form.toggleAddButton(false, "");
    this.form.handleErrorMessage();
    this.updateInventoryNoticeDisplay(this.currentVariant.available);

    if (!this.currentVariant) {
      this.form.toggleAddButton(true, "");
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.form.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.querySelectorAll('input[name="options[Width]"]').forEach((input) => {
      input.nextElementSibling.classList.toggle("is-active", input.checked);
    });
    this.querySelectorAll('input[name="options[Color]"]').forEach((input) => {
      input.nextElementSibling.classList.toggle("is-active", input.checked);
    });
    this.querySelectorAll('input[name="options[Amount]"]').forEach((input) => {
      input.nextElementSibling.classList.toggle("is-active", input.checked);
    });
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el) => ({ name: el.dataset.name || el.name, value: el.value })
    );
  }

  productBarUpdateOptions() {
    if (this.productBar) {
      Array.from(this.productBar.querySelectorAll("select")).map((selector) => {
        selector.value = this.options.find(
          (option) => option.name === selector.name
        ).value;
      });
      this.productBar.querySelectorAll("dropdown-input").forEach((dropdown) => {
        dropdown.update();
      });
    }
  }

  updateInventoryNotice(html) {
    const destination = document.querySelector("[data-inventory-notice]");
    const source = html.querySelector("[data-inventory-notice]");

    if (source && destination) destination.innerHTML = source.innerHTML;

    // Pass the inventory quantity from source to the quantity input
    const inventoryQuantityMatch = source?.textContent.match(/\d+/);
    const inventoryQuantity = inventoryQuantityMatch
      ? parseInt(inventoryQuantityMatch[0])
      : 0;
    this.updateQuantityInput(inventoryQuantity);
  }

  updateQuantityInput(inventoryQuantity) {
    const selectedVariantData = this.getVariantData();
    const quantityInput = document.querySelector(
      ".product-selector__quantity quantity-input input"
    );

    let productUsesInventory = true;

    // check inventory is active
    if (
      selectedVariantData &&
      selectedVariantData.inventory_management === null
    ) {
      productUsesInventory = false;
    }

    // check sell on sold out is active
    if (
      selectedVariantData &&
      selectedVariantData.inventory_quantity !== null &&
      inventoryQuantity === 0 &&
      selectedVariantData.available === true
    ) {
      productUsesInventory = false;
    }

    if (productUsesInventory) {
      quantityInput.setAttribute("max", inventoryQuantity);
      // set value accordingly to inventory
      if (quantityInput.value > inventoryQuantity) {
        // quantityInput.value = inventoryQuantity;
      }
    } else {
      quantityInput.setAttribute("max", "");
    }
  }

  updatePickupAvailability() {
    const pickUpAvailabilityNode = document.querySelector(
      "pickup-availability"
    );

    if (!pickUpAvailabilityNode || !this.currentVariant) return;

    pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailabilityNode.setAttribute("available", "");
      pickUpAvailabilityNode.fetchAvailability(
        pickUpAvailabilityNode.dataset.variantId
      );

      return;
    }

    pickUpAvailabilityNode.removeAttribute("available");
    pickUpAvailabilityNode.innerHTML = "";
  }

  updateVariant() {
    this.currentVariant = this.getVariantData();
  }

  getVariantData() {
    if (this.options.length === 0) {
      return this.variants[0]; // Return the first variant if no options are selected
    }

    return this.variants.find((variant) => {
      // Check if the variant's options match the selected options
      return this.options.every((option) => {
        const optionIndex =
          this.options.findIndex((opt) => opt.name === option.name) + 1;
        return variant[`option${optionIndex}`] === option.value;
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector("product-media");
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL(sellingPlanId) {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    if (sellingPlanId) {
      params[params.has("selling_plan") ? "set" : "append"](
        "selling_plan",
        sellingPlanId
      );
    } else {
      params.delete("selling_plan");
    }
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const inputs = [
      this.querySelector('[name="id"]'),
      this.installmentsForm?.querySelector('[name="id"]'),
    ];
    inputs.forEach((input) => {
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  setUnavailable() {
    const submitButton = this.form.submitButton;
    const price = this.querySelector(
      `#Product-Price-${this.dataset.sectionId}`
      `#Product-Price-Mobile-${this.dataset.sectionId}`
    );
    const inventoryNotice = document.querySelector(
      ".product__inventory-notice"
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventoryNotice) inventoryNotice.style.display = "none";
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    params.append("section_id", this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        [
          `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`,
        ].map((liveRegionSelector) => {
          const destination = document.querySelector(liveRegionSelector);
          const source = html.querySelector(liveRegionSelector);

          this.updateInventoryNotice(html);

          if (destination && source) {
            destination.classList.remove("visibility-hidden");
            destination.innerHTML = source.innerHTML;
          }
        });
        const htmlMb = new DOMParser().parseFromString(responseText, "text/html");
        [
          `#Product-Price-Mobile-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`,
        ].map((liveRegionSelector) => {
          const destination = document.querySelector(liveRegionSelector);
          const source = htmlMb.querySelector(liveRegionSelector);

          this.updateInventoryNotice(htmlMb);

          if (destination && source) {
            destination.classList.remove("visibility-hidden");
            destination.innerHTML = source.innerHTML;
          }
        });

        const priceHasBadge = document.querySelector('.product__grid__item--content .price__sale--has-badge')
        const finals = document.querySelectorAll('.section-complete-the-set .final-sale-text');
        if (priceHasBadge.querySelector('.finalsale-text')) {
          finals.forEach(function(i, index) {
            if (i.closest('.rte').querySelector('.not-final-sale-text')) {
              i.closest('.rte').querySelector('.not-final-sale-text').classList.add('hidden');
            }
            i.classList.remove('hidden');
          });
        } else {
          finals.forEach(function(i, index) {
            if (i.closest('.rte').querySelector('.not-final-sale-text')) {
              i.closest('.rte').querySelector('.not-final-sale-text').classList.remove('hidden');
            }
            i.classList.add('hidden');
          });
        }
      });
  }
  toggleForm() {
    const items = document.querySelectorAll(".option-size");
    const labels = document.querySelectorAll(".option-size + label");
    const atcForm = document.querySelector(".product-form-toggle");
    const selectSizeForm = document.querySelector(
      ".product-select-size-button"
    );

    labels.forEach((i) => i.classList.remove("is-active"));

    items.forEach((item) => {
      item.nextElementSibling.addEventListener("click", function () {
        labels.forEach((i) => i.classList.remove("is-active"));
        this.classList.add("is-active");

        // show atc form
        atcForm.classList.remove("hidden");
        selectSizeForm.classList.add("hidden");
      });
    });
  }

  hideUnavailableVariants() {
    const pickerType = document.querySelector("product-selector")
      ? "radios"
      : "selects";
    const variantSelects =
      pickerType == "radios"
        ? document.querySelector("product-selector")
        : document.querySelector("variant-selects");
    const fieldsets =
      pickerType == "radios"
        ? Array.from(variantSelects.querySelectorAll("fieldset"))
        : Array.from(
            variantSelects.querySelectorAll(".product-form__input--dropdown")
          );
    const productJson = JSON.parse(
      variantSelects.querySelector('[type="application/json"]').textContent
    );
    let selectedOptions = [];

    variantSelects.addEventListener("change", rebuildOptions);
    rebuildOptions();

    // gather a list of valid combinations of options, check to see if the input passed to it matches in a chain of valid options.
    function validCombo(inputValue, optionLevel) {
      for (let i = 0; i < productJson.length; i++) {
        if (optionLevel == 1) {
          if (
            productJson[i].option1 == selectedOptions[0] &&
            productJson[i].option2 == inputValue
          ) {
            return true;
          }
        } else {
          if (
            productJson[i].option1 == selectedOptions[0] &&
            productJson[i].option2 == selectedOptions[1] &&
            productJson[i].option3 == inputValue
          ) {
            return true;
          }
        }
      }
      return false;
    }

    function rebuildOptions() {
      selectedOptions = fieldsets.map((fieldset) => {
        return pickerType == "radios"
          ? Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            ).value
          : Array.from(
              fieldset.querySelectorAll("select"),
              (select) => select.value
            );
      });
      //loop through the option sets starting from the 2nd set and disable any invalid options
      for (
        let optionLevel = 1, n = fieldsets.length;
        optionLevel < n;
        optionLevel++
      ) {
        const inputs =
          pickerType == "radios"
            ? fieldsets[optionLevel].querySelectorAll("input")
            : fieldsets[optionLevel].querySelectorAll("option");

        inputs.forEach((input) => {
          input.disabled = validCombo(input.value, optionLevel) ? false : true;
          if (pickerType == "radios") {
            //get the label for the current input (this is what the user clicks, the "pill")
            const label = fieldsets[optionLevel].querySelector(
              `label[for="${input.id}"]`
            );

            label.style.display = input.disabled ? "none" : ""; //Hide the option, or comment this line out and use the following lines to style it..
            //label.style.opacity = (input.disabled) ? 0.5 : 1;
            //label.style.borderStyle = (input.disabled) ? "dashed" : "solid";
            //label.style.textDecoration = (input.disabled) ? "none" : "";
          } else {
            input.hidden = validCombo(input.value, optionLevel) ? false : true;
          }
        });
      }

      //if the default selected option is disabled with the function above, select the first available option instead
      for (
        let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
        optionLevel < fieldsetsLength && !change;
        optionLevel++
      ) {
        if (pickerType == "radios") {
          if (
            fieldsets[optionLevel].querySelector("input:checked").disabled ===
            true
          ) {
            change = fieldsets[optionLevel].querySelector(
              "input:not(:disabled)"
            ).checked = true;
          }
        } else {
          if (
            fieldsets[optionLevel].querySelector("option:checked").disabled ===
            true
          ) {
            change = fieldsets[optionLevel].querySelector(
              "option:not(:disabled)"
            ).selected = "selected";
          }
        }
        //if a new option has been selected, restart the whole process
        if (change)
          variantSelects.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  updateVariantLabel() {
    if (!isTouchDevice()) {
      var colorwayElements = document.querySelectorAll(".each_colorway");

      colorwayElements.forEach(function (element) {
        element.addEventListener("mouseover", function (e) {
          if (element.classList.contains("each_colorway_new_colors")) {
            thisColorNew(element);
          } else {
            thisColor(element);
          }
        });

        element.addEventListener("mouseleave", function () {
          getCurrentSelection();
        });
      });
    }

    function isTouchDevice() {
      return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    }

    function getCurrentSelection() {
      const currentColorway = document.querySelector(".current_selection");
      const normalLabel = document.querySelector(".colorway_label");
      const newColorLabel = document.querySelector(
        ".colorway_label--new-colors"
      );
      if (currentColorway) {
        let color = currentColorway.getAttribute("data-name");
        const hasNormalClass = currentColorway.classList.contains(
          "each_colorway_normal"
        );
        const hasNewColorsClass = currentColorway.classList.contains(
          "each_colorway_new_colors"
        );
        if (hasNormalClass) {
          normalLabel.style.opacity = 0;
          if (newColorLabel) {
            newColorLabel.style.opacity = 0;
          }
          setTimeout(function () {
            normalLabel.textContent = color;
          }, 0);
          setTimeout(function () {
            normalLabel.style.opacity = 1;
          }, 0);
        } else if (hasNewColorsClass) {
          normalLabel.style.opacity = 0;
          if (newColorLabel) {
            newColorLabel.style.opacity = 0;
            setTimeout(function () {
              newColorLabel.textContent = color;
            }, 0);
            setTimeout(function () {
              newColorLabel.style.opacity = 1;
            }, 0);
          }
        }
      }
    }

    function thisColor(element) {
      const colorwayLabel = ".colorway_label";
      let color_label = document.querySelector(colorwayLabel);
      let hover_color = element.getAttribute("data-name");
      color_label.style.opacity = 0;
      setTimeout(function () {
        color_label.textContent = hover_color;
      }, 0);
      setTimeout(function () {
        color_label.style.opacity = 1;
      }, 0);
    }

    function thisColorNew(element) {
      const colorwayLabel = ".colorway_label--new-colors";
      let color_label = document.querySelector(colorwayLabel);
      let hover_color = element.getAttribute("data-name");
      color_label.style.opacity = 0;
      setTimeout(function () {
        color_label.textContent = hover_color;
      }, 0);
      setTimeout(function () {
        color_label.style.opacity = 1;
      }, 0);
    }
  }

  variantColorSwatch() {
    // Remove unexpected normal and new color elements
    (() => {
      const normalNewColor = document.querySelectorAll(
        ".variant-normal-color .is-new-color"
      );
      normalNewColor.forEach((i) => {
        i.remove();
      });
      const newNormalColor = document.querySelectorAll(
        ".variant-new-color li:not(.is-new-color)"
      );
      newNormalColor.forEach((i) => {
        i.remove();
      });
    })();

    const variantImgs = document.querySelectorAll(
      ".color-swatches-trigger .product-swatch-image"
    );

    variantImgs.forEach((item) => {
      const variantImgSrc = item.querySelector("img").src;
      const variantLabelElement = item.querySelector("label.swatch");
      const variantLabelName = variantLabelElement.getAttribute("title");

      // Update label
      const variantColors = document.querySelectorAll(
        '.variant-normal-color .product-swatch-image input[name="options[Color]"] + label'
      );
      variantColors.forEach((i) => {
        const variantColorLabelElement = i.closest(
          ".variant-normal-color label.swatch"
        );
        const variantColorLabelName =
          variantColorLabelElement.getAttribute("title");

        if (variantColorLabelName == variantLabelName) {
          const imgElement = i.querySelector("img");
          if (imgElement) {
            imgElement.src = variantImgSrc;
          }
        }

        // default first variant
        variantColors[0].classList.add("is-active");

        if (i.classList.contains("is-active")) {
          const currentColorLabel = i.getAttribute("title");
          const colorLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-normal-color-label .colorway_label"
          );
          colorLabel.innerHTML = currentColorLabel;
        }

        i.addEventListener("click", () => {
          const currentColorLabel = i.getAttribute("title");
          const colorLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-normal-color-label .colorway_label"
          );
          colorLabel.innerHTML = currentColorLabel;
          const colorNewLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-new-color-label .colorway_label"
          );
          if (colorNewLabel) {
            colorNewLabel.innerHTML = "";
          }
        });

        i.addEventListener("mouseover", () => {
          const currentColorLabel = i.getAttribute("title");
          const colorLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-normal-color-label .colorway_label"
          );
          colorLabel.innerHTML = currentColorLabel;
        });
      });

      // Update new color label
      const variantNewColors = document.querySelectorAll(
        '.variant-new-color .product-swatch-image input[name="options[Color]"] + label'
      );
      variantNewColors.forEach((i) => {
        const variantColorLabelElement = i.closest(
          ".variant-new-color label.swatch"
        );
        const variantColorLabelName =
          variantColorLabelElement.getAttribute("title");

        if (variantColorLabelName == variantLabelName) {
          const imgElement = i.querySelector("img");
          if (imgElement) {
            imgElement.src = variantImgSrc;
          }
        }

        if (i.classList.contains("is-active")) {
          const currentColorLabel = i.getAttribute("title");
          const colorNewLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-new-color-label .colorway_label"
          );
          colorNewLabel.innerHTML = currentColorLabel;
        }

        i.addEventListener("click", () => {
          const currentColorLabel = i.getAttribute("title");
          const colorNewLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-new-color-label .colorway_label"
          );
          colorNewLabel.innerHTML = currentColorLabel;
          const colorLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-normal-color-label .colorway_label"
          );
          colorLabel.innerHTML = "";
        });

        i.addEventListener("mouseover", () => {
          const currentColorLabel = i.getAttribute("title");
          const colorNewLabel = document.querySelector(
            ".product-selector__label--wrapper.variant-new-color-label .colorway_label"
          );
          colorNewLabel.innerHTML = currentColorLabel;
        });
      });

      // Update color label on mouseleave
      const variantGenColors = document.querySelectorAll(
        '.product-swatch-image input[name="options[Color]"] + label'
      );
      document
        .querySelector(
          '.product-swatch-image input[name="options[Color]"] + label.is-active'
        )
        .closest(".product__swatches")
        .classList.add("parent-active");
      variantGenColors.forEach((i) => {
        i.addEventListener("click", () => {
          document
            .querySelectorAll(".product__swatches")
            .forEach((e) => e.classList.remove("parent-active"));

          i.closest(".product__swatches").classList.add("parent-active");
        });

        i.addEventListener("mouseleave", () => {
          const activeElement = document.querySelector(
            '.product-swatch-image input[name="options[Color]"] + label.is-active'
          );

          const activeParentElementNormal = document.querySelector(
            ".product__swatches.variant-normal-color.parent-active"
          );
          if (activeParentElementNormal) {
            if (activeElement) {
              const activeColorLabel = activeElement.getAttribute("title");
              const colorLabel = document.querySelector(
                ".product-selector__label--wrapper.variant-normal-color-label .colorway_label"
              );
              colorLabel.innerHTML = activeColorLabel;
            }
          } else {
            const colorLabel = document.querySelector(
              ".product-selector__label--wrapper.variant-normal-color-label .colorway_label"
            );
            colorLabel.innerHTML = "";
          }

          const ParentElementNew = document.querySelector(
            ".product__swatches.variant-new-color"
          );
          const activeParentElementNew = document.querySelector(
            ".product__swatches.variant-new-color.parent-active"
          );
          if (ParentElementNew) {
            if (activeParentElementNew) {
              if (activeElement) {
                const activeColorLabel = activeElement.getAttribute("title");
                const colorLabel = document.querySelector(
                  ".product-selector__label--wrapper.variant-new-color-label .colorway_label"
                );
                colorLabel.innerHTML = activeColorLabel;
              }
            } else {
              const colorLabel = document.querySelector(
                ".product-selector__label--wrapper.variant-new-color-label .colorway_label"
              );
              colorLabel.innerHTML = "";
            }
          }
        });
      });
    });
  }
}

customElements.define("product-selector", ProductSelector);
